import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Siswa from "./pages/Siswa";
import Guru from "./pages/Guru";
import Laporan from "./pages/Laporan";
import ProgramKekhususan, { LembarEvaluasi } from "./pages/ProgramKekhususan";
import { ProfilAdminKoord, ProfilSiswaPage, ProfilGuruPage } from "./pages/Profil";
import { Gaji, SPP, LaporanKeuangan, AbsensiGuru } from "./pages/Administrasi";
import { Users, Backup, LogAktivitas, IzinGuru } from "./pages/Manajemen";
import { Pendampingan, BukuBatas, AbsensiSiswa, BukuPenghubung } from "./pages/Dokumen";
import { Kendala, Pemberitahuan, Saran, HubungiKami } from "./pages/Komunikasi";
import { Loading } from "./components/Shared";

const Guard = ({ roles }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><Loading /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
};

const ProfilRoute = () => {
  const { user } = useAuth();
  return <ProfilAdminKoord role={user.role === "admin" ? "admin" : "koordinator"} />;
};
const IzinRoute = () => { const { user } = useAuth(); return <IzinGuru role={user.role} />; };

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Navigate to="/dashboard" replace /> : children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
          <Route element={<Guard />}>
            <Route element={<Layout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route element={<Guard roles={["admin", "koordinator"]} />}>
                <Route path="/profil" element={<ProfilRoute />} />
                <Route path="/siswa" element={<Siswa />} />
                <Route path="/guru" element={<Guru />} />
                <Route path="/spp" element={<SPP />} />
                <Route path="/keuangan" element={<LaporanKeuangan />} />
                <Route path="/pendampingan" element={<Pendampingan />} />
              </Route>
              <Route element={<Guard roles={["admin"]} />}>
                <Route path="/profil-koordinator" element={<ProfilAdminKoord role="koordinator" />} />
                <Route path="/users" element={<Users />} />
                <Route path="/backup" element={<Backup />} />
                <Route path="/log" element={<LogAktivitas />} />
              </Route>
              <Route element={<Guard roles={["admin", "koordinator", "guru"]} />}>
                <Route path="/gaji" element={<Gaji />} />
                <Route path="/kendala" element={<Kendala />} />
                <Route path="/buku-batas" element={<BukuBatas />} />
                <Route path="/izin-guru" element={<IzinRoute />} />
              </Route>
              <Route element={<Guard roles={["guru", "ortu"]} />}>
                <Route path="/profil-siswa" element={<ProfilSiswaPage />} />
                <Route path="/profil-guru" element={<ProfilGuruPage />} />
              </Route>
              <Route element={<Guard roles={["koordinator", "guru", "ortu"]} />}>
                <Route path="/absensi-siswa" element={<AbsensiSiswa />} />
                <Route path="/buku-penghubung" element={<BukuPenghubung />} />
                <Route path="/laporan" element={<Laporan />} />
                <Route path="/program-kekhususan" element={<ProgramKekhususan />} />
                <Route path="/program-kekhususan/:id" element={<LembarEvaluasi />} />
                <Route path="/pemberitahuan" element={<Pemberitahuan />} />
              </Route>
              <Route element={<Guard roles={["koordinator", "ortu"]} />}>
                <Route path="/saran" element={<Saran />} />
              </Route>
              <Route path="/absensi-guru" element={<AbsensiGuru />} />
              <Route path="/hubungi-kami" element={<HubungiKami />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
